module.exports = __webpack_public_path__ + "static/media/chocolates.1432c316.svg";